var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"m-badge",class:{'with-icon': _vm.withIcon},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"m-badge__text"},[_vm._t("default")],2),(_vm.withIcon)?_c('m-icon',{attrs:{"icon":"ad"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }